import React, { useEffect, useState } from "react";
import UISectionHeading from "../Common/UISectionHeading/UISectionHeading";
import UiButton from "../Common/UiButton/UiButton";
import { Col, Row } from "react-bootstrap";
import TextInput from "../Common/UITextInput/TextInput";
import { Form, Checkbox, Select, Tag, message, notification } from "antd";
import useForm from "../Common/hooks/useForm";
import UiDropDown from "../Common/UiDropDown/UiDropDown";
import "../FirmHeadOfficeDetalis/FirmHeadOfficeDetalis.css";
import { connect, useSelector } from "react-redux";
import {
  getSVMListTeams,
  getPincodeOnSearch,
  getBranchLocationByPincode,
  getBranchLocationByArea,
  postTeamDetails,
  getCurrentAddressTeams,
  getPermanentAddressTeams,
} from "../../redux/TeamDetails/action";
import AsyncSelect from "react-select/async";
import { NumberInput } from "../../common/UITextInput/TextInput";
import useSession from "../CustomLogout/useSession";

const TeamDetailsCurrentAddress = (props) => {
  const handleSessionExpired = useSession();

  const [current, setCurrent] = useState(true);

  const { saveAllIndication, setHandleGetTeamAddress } = props;
  const [btnDisable, setBtnDisable] = useState(false);
  const [pincodeCurId, setCurPincodeId] = useState(0);
  const [selectedCurPincode, setSelectedCurPincode] = useState([]);
  const [CurinputValue, setCurValue] = React.useState("");
  const [fieldPermissions, setFieldPermissions] = useState([]);
  const [Curarea, setCurArea] = useState("");
  const [cityCurId, setCurCityId] = useState("");
  const [stateCurId, setCurStateId] = useState("");
  const [countryCurId, setCurCountryId] = useState("");
  const [landmark, setLandmark] = useState("");
  const [cityCurName, setCurCityName] = useState("");
  const [countryCurName, setCurCountryName] = useState("");

  const [pincodePerId, setPerPincodeId] = useState(0);
  const [selectedPerPincode, setSelectedPerPincode] = useState([]);
  const [PerinputValue, setPerValue] = React.useState("");
  const [Perarea, setPerArea] = useState("");
  const [cityPerId, setPerCityId] = useState("");
  const [statePerId, setPerStateId] = useState("");
  const [countryPerId, setPerCountryId] = useState("");
  const [cityPerName, setPerCityName] = useState("");
  const [countryPerName, setPerCountryName] = useState("");

  const [ownStatusOptions1, setOwnStatusOptions1] = useState([]);
  const [ownStatusOptions2, setOwnStatusOptions2] = useState([]);
  const [currOwnStatus1, setCurrOwnStatus1] = useState("");
  const [currOwnStatus2, setCurrOwnStatus2] = useState("");
  const [Teamdata, setTeamData] = useState(
    useSelector((state) => state.TeamDetails)
  );

  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const { state, onChangeTextHandler } = useForm();
  let pincodeArray = [];
  const { setFieldsValue, resetFields, validateFieldsAndScroll } = form;
  const { access_token, formData } = props;

  // useEffect(() => {
  //   setCurrent(Teamdata?.per?.sameAsCurrentAddress)

  // }, [Teamdata])
  useEffect(() => {
    if (
      props?.personId !== undefined &&
      props.data?.per?.sameAsCurrentAddressFlag == true
    ) {
      setCurrent(!props.data?.per?.sameAsCurrentAddressFlag);
    }
    if (
      props?.personId !== undefined &&
      props.data?.per?.sameAsCurrentAddressFlag == false
    ) {
      setCurrent(!props.data?.per?.sameAsCurrentAddressFlag);
    }

    if (props?.personId == undefined) {
      resetFields();
      setCurCityId("");
      setPerCityId("");
      setCurCountryId("");
      setPerCountryId("");
      setPerPincodeId("");
      setCurPincodeId("");
    }

    if (props?.personId == undefined) {
      setCurrent(false);
    }

    if (
      props.data?.Current?.address?.addressLine1 == undefined &&
      props?.data?.Current?.address?.addressLine2 == undefined &&
      props?.personId !== undefined
    ) {
      resetFields();
      setCurCityId("");
      setPerCityId("");
      setCurCountryId("");
      setPerCountryId("");
      setPerPincodeId("");
      setCurPincodeId("");
    }
  }, [props.personId, props.data]);

  useEffect(() => {
    if (saveAllIndication) {
      form.submit();
    }
  }, [saveAllIndication]);

  useEffect(() => {
    if (
      current == false &&
      props.data?.Current?.address?.addressLine1 != undefined &&
      // props.data?.Current?.address?.addressLine2 != undefined &&
      props?.personId !== undefined
    ) {
      setFieldsValue({
        city_Cur: props.data?.Current?.address?.cityName,
        country_Cur: props.data?.Current?.address?.countryName,
        teamCurrentaddressLine1: props.data?.Current?.address?.addressLine1,
        teamCurrentaddressLine2: props.data?.Current?.address?.addressLine2,
        teamCurrentEmailAddress: props.data?.Current?.emailAddress,
        teamCurrentphoneNumber: props.data?.Current?.phoneNumbers?.join(","),
        teamCurrentMobileNumber: props.data?.Current?.mobileNumbers?.join(","),
        teamCurrentFaxNumber: props.data?.Current?.faxNumber,
        teamCurrentArea: props.data?.Current.address?.area,
        teamCurrentTearsAtCurrentAdd:
          props.data?.Current.address?.yearsAtCurrentAddress,
        teamCurrentYearInCity: props.data?.Current?.address?.yearsInCurrentCity,
        locality: props.data?.Current?.locality,
        teamCurrentAreaPincode: {
          label: props.data?.Current?.address?.pincode,
          value: props.data?.Current?.address?.pincode,
        },

        teamCurrentOwnership: {
          value: props.data?.Current?.officeOwnership?.id,
          label: props.data?.Current?.officeOwnership?.name,
        },
      });

      setCurCityId(props.data?.Current?.address?.cityId);
      setCurCountryId(props.data?.Current?.address?.countryId);
      setCurPincodeId(props.data?.Current?.address?.pincodeId);
    }

    if (
      current == true &&
      props.data?.Current?.address?.addressLine1 != undefined &&
      // props.data?.Current?.address?.addressLine2 != undefined &&
      props?.personId !== undefined
    ) {
      setFieldsValue({
        PermanentsaddressLine1: props.data?.per?.address?.addressLine1,
        permanentsAddressLocality: props.data?.per?.locality,
        PermanentsaddressLine2: props.data?.per?.address?.addressLine2,
        permanentsAddressArea: props.data?.per?.address?.area,
        permanentsAddressLandmark: props.data?.per?.address?.landmark,
        city_Cur: props.data?.Current?.address?.cityName,
        city_per: props.data?.per?.address?.cityName,
        country_Cur: props.data?.Current?.address?.countryName,
        country_per: props.data?.per?.address?.countryName,

        permanentsAddressMobileNumber:
          props.data?.per?.mobileNumbers?.join(","),
        permanentsAddressphoneNumber: props.data?.per?.phoneNumbers?.join(","),
        permanentsAddressFaxNumber: props.data?.per?.faxNumber,
        permanentsAddressEmailAddress: props.data?.per?.emailAddress,
        teamCurrentaddressLine1: props.data?.Current?.address?.addressLine1,
        teamCurrentaddressLine2: props.data?.Current?.address?.addressLine2,
        teamCurrentEmailAddress: props.data?.Current?.emailAddress,
        teamCurrentLandmark: props.data?.Current?.address?.landmark,
        teamCurrentphoneNumber: props.data?.Current?.phoneNumbers?.join(","),
        teamCurrentMobileNumber: props.data?.Current?.mobileNumbers?.join(","),
        teamCurrentFaxNumber: props.data?.Current?.faxNumber,
        teamCurrentTearsAtCurrentAdd:
          props.data?.Current.address?.yearsAtCurrentAddress,
        teamCurrentYearInCity: props.data?.Current?.address?.yearsInCurrentCity,
        locality: props.data?.Current?.locality,
        teamCurrentArea: props.data?.Current.address?.area,
        teamCurrentAreaPincode: {
          label: props.data?.Current?.address?.pincode,
          value: props.data?.Current?.address?.pincode,
        },
        permanentsAddressAreaPincode: {
          label: props.data?.per?.address?.pincode,
          value: props.data?.per?.address?.pincode,
        },

        teamCurrentOwnership: {
          value: props.data?.Current?.officeOwnership?.id,
          label: props.data?.Current?.officeOwnership?.name,
        },
      });

      setCurCityId(props.data?.Current?.address?.cityId);
      setPerCityId(props.data?.Current?.address?.cityId);
      setCurCountryId(props.data?.Current?.address?.countryId);
      setPerCountryId(props.data?.per?.address?.countryId);
      setPerPincodeId(props.data?.per?.address?.pincodeId);
      setCurPincodeId(props.data?.Current?.address?.pincodeId);
    }
  }, [current, props.data, props?.personId]);

  useEffect(() => {
    props
      .getsvmdata({
        access_token,
        url: "ByName",
        name: "PARTNER_OFFICE_OWNERSHIP",
      })
      .then((res) => {
        if (res) {
          if (res && res.data?.dtoList?.length && res.status === 200) {
            const values = [];
            res &&
              res?.data?.dtoList?.map((item) => {
                values.push({
                  value: item?.serialId,
                  label: item?.value,
                });
                setOwnStatusOptions1(values);
                // setOwnStatusOptions(values);
              });
            // setOwnStatusOptions(values);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  }, []);

  React.useEffect(() => {
    props
      .getsvmdata({
        access_token,
        url: "ByName",
        name: "OFFICE_IN_LOCALITY",
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const values = [];
            res &&
              res.data?.dtoList?.length &&
              res?.data?.dtoList?.map((item) => {
                values.push({
                  value: item?.serialId,
                  label: item?.value,
                });
                setOwnStatusOptions2(values);
                //setOwnStatusOptions(values);
              });
            // setOwnStatusOptions(values);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  }, []);

  const loadPinCurcodes = (inputValue, callback) => {
    if (inputValue.length > 2) {
      props
        .getPincodeList({
          access_token,
          inputValue,
        })
        .then((res) => {
          // message.loading("Please Wait...", 5);

          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  label: element.pincode,
                  value: element.pincodeId,
                };
                pincodeArray.push(values);
              });
            callback(pincodeArray);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    }
  };

  const pincodeDropCurChange = (pincodeObj) => {
    setSelectedCurPincode(pincodeObj.label);
    // getPincodeCurData(pincodeObj.value);
    getBranchCurLocationMaster(pincodeObj.value);
  };

  const getPincodeCurData = (pincode) => {
    props
      .getBranchLocationByArea({
        access_token,
        url: "getAll/Pincodes",
        pincode: pincode,
      })
      .then((res) => {
        const pincodeObj =
          res && res.data && res.data.dtoList && res.data.dtoList.length > 0
            ? res.data.dtoList.filter((pin) => pin.pincode == pincode)
            : "";
        const pincodeId =
          pincodeObj?.length > 0
            ? pincodeObj?.map((p) => p.pincodeId)?.flat(2)
            : "";

        setCurPincodeId(pincodeId?.length > 0 && pincodeId[0]);
        getBranchCurLocationMaster(pincodeId?.length > 0 && pincodeId[0]);

        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const getBranchCurLocationMaster = (pincodeId) => {
    props
      .getBranchLocationByPincode({
        access_token,
        url: "getAll/LocationsUsingPincodeId",
        pincode: pincodeId,
        data: {
          pincodeMaster: {
            pincodeId: pincodeId,
            pincode: CurinputValue,
            cityId: cityCurId,
            serviceable: true,
            groupId: 1,
            area: Curarea,
            active: true,
          },

          cityMaster: {
            cityName: cityCurName,
            cityId: cityCurId,
          },
          countryMaster: {
            countryId: countryCurId,
            countryName: countryCurName,
          },
        },
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const { pincodeMaster, countryMaster, cityMaster, stateMaster } =
              res?.data;
            setCurPincodeId(pincodeMaster?.pincodeId);
            setCurArea(pincodeMaster?.area);
            setCurCityId(cityMaster?.cityId);
            setCurStateId(stateMaster?.stateId);
            setCurCountryId(countryMaster?.countryId);
            setCurCityName(cityMaster?.cityName);
            setCurCountryName(countryMaster?.countryName);
            setFieldsValue({
              area_: pincodeMaster.area,
              city_Cur: cityMaster?.cityName,
              country_Cur: countryMaster?.countryName,
            });
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const pincodeInputCurChange = (value) => {
    setCurValue(value);
  };

  const loadPinPercodes = (inputValue, callback) => {
    if (inputValue.length > 2) {
      props
        .getPincodeList({
          access_token,
          inputValue,
        })
        .then((res) => {
          // message.loading("Please Wait...", 5);

          if (res && res.status === 200) {
            res?.data?.dtoList?.length > 0 &&
              res?.data?.dtoList?.forEach(function (element) {
                const values = {
                  label: element.pincode,
                  value: element.pincodeId,
                };
                pincodeArray.push(values);
              });
            callback(pincodeArray);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    }
  };

  const pincodeDropPerChange = (pincodeObj) => {
    setSelectedPerPincode(pincodeObj.label);
    // getPincodePerData(pincodeObj.value);
    getBranchPerLocationMaster(pincodeObj.value);
  };

  const getPincodePerData = (pincode) => {
    props
      .getBranchLocationByArea({
        access_token,
        url: "getAll/Pincodes",
        pincode: pincode,
      })
      .then((res) => {
        const pincodeObj =
          res && res.data && res.data.dtoList && res.data.dtoList.length > 0
            ? res.data.dtoList.filter((pin) => pin.pincode == pincode)
            : "";
        const pincodeId =
          pincodeObj?.length > 0
            ? pincodeObj?.map((p) => p.pincodeId)?.flat(2)
            : "";

        setPerPincodeId(pincodeId?.length > 0 && pincodeId[0]);
        getBranchPerLocationMaster(pincodeId?.length > 0 && pincodeId[0]);

        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const getBranchPerLocationMaster = (pincodeId) => {
    props
      .getBranchLocationByPincode({
        access_token,
        url: "getAll/LocationsUsingPincodeId",
        pincode: pincodeId,
        data: {
          pincodeMaster: {
            pincodeId: pincodeId,
            pincode: PerinputValue,
            cityId: cityPerId,
            serviceable: true,
            groupId: 1,
            area: Perarea,
            active: true,
          },

          cityMaster: {
            cityName: cityPerName,
            cityId: cityPerId,
          },
          countryMaster: {
            countryId: countryPerId,
            countryName: countryPerName,
          },
        },
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            const { pincodeMaster, countryMaster, cityMaster, stateMaster } =
              res?.data;
            setPerPincodeId(pincodeMaster?.pincodeId);
            setPerArea(pincodeMaster?.area);
            setPerCityId(cityMaster?.cityId);
            setPerStateId(stateMaster?.stateId);
            setPerCountryId(countryMaster?.countryId);
            setPerCityName(cityMaster?.cityName);
            setPerCountryName(countryMaster?.countryName);
            setFieldsValue({
              area_: pincodeMaster.area,
              city_per: cityMaster?.cityName,
              country_per: countryMaster?.countryName,
            });
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const pincodeInputPerChange = (value) => {
    setPerValue(value);
  };

  function submit(data) {
    setBtnDisable(true);
    let values;

    if (current == false) {
      values = {
        permanentAddressDTO: {
          address: {
            addressLine1: data.teamCurrentaddressLine1?.trim(),
            addressLine2: data.teamCurrentaddressLine2?.trim(),
            area: data.teamCurrentArea?.trim(),

            cityId: cityCurId,
            cityName: data.city_Cur?.trim(),
            countryId: countryCurId,
            countryName: data.country_Cur?.trim(),
            landmark: data.teamCurrentLandmark?.trim(),

            ownershipStatus: 2,
            pincode: data.teamCurrentAreaPincode.label,
            pincodeId: pincodeCurId,
            stateId: null,
            stateName: null,
            yearsAtCurrentAddress: data.teamCurrentTearsAtCurrentAdd,
            yearsInCurrentCity: data.teamCurrentYearInCity,
            sameAsCurrentAddressFlag: !current,
          },
          emailAddress: data.teamCurrentEmailAddress?.trim(),
          faxNumber: data.teamCurrentFaxNumber,
          locality: data.permanentsAddressLocality?.trim(),
          mobileNumbers: data.teamCurrentMobileNumber?.trim().split(","),

          // officeOwnership: {
          //   id: data.teamCurrentOwnership.value,
          //   name: data.teamCurrentOwnership.label,
          // },
          phoneNumbers: data.teamCurrentphoneNumber?.trim().split(","),
          sameAsCurrentAddressFlag: !current,
        },
        currentAddressDTO: {
          address: {
            addressLine1: data.teamCurrentaddressLine1?.trim(),
            addressLine2: data.teamCurrentaddressLine2?.trim(),
            area: data.teamCurrentArea,

            cityId: cityCurId,
            cityName: data.city_Cur?.trim(),
            countryId: countryCurId,
            countryName: data.country_Cur?.trim(),
            landmark: data.teamCurrentLandmark?.trim(),

            ownershipStatus: 2,
            pincode: data.teamCurrentAreaPincode.label,
            pincodeId: pincodeCurId,
            stateId: null,
            stateName: null,
            yearsAtCurrentAddress: data.teamCurrentTearsAtCurrentAdd,
            yearsInCurrentCity: data.teamCurrentYearInCity,
          },
          emailAddress: data.teamCurrentEmailAddress?.trim(),
          faxNumber: data.teamCurrentFaxNumber,
          locality: data.locality?.trim(),
          mobileNumbers: data.teamCurrentMobileNumber?.trim().split(","),

          officeOwnership: {
            id: data.teamCurrentOwnership.value,
            name: data.teamCurrentOwnership.label,
          },
          phoneNumbers: data.teamCurrentphoneNumber?.trim().split(","),
        },
      };
    } else {
      values = {
        permanentAddressDTO: {
          address: {
            addressLine1: data.PermanentsaddressLine1?.trim(),
            addressLine2: data.PermanentsaddressLine2?.trim(),
            area: data.permanentsAddressArea?.trim(),
            cityId: cityPerId,
            cityName: data.city_per?.trim(),

            countryId: countryPerId,
            countryName: data.country_per?.trim(),
            landmark: data.permanentsAddressLandmark?.trim(),
            ownershipStatus: null,
            pincode: data.permanentsAddressAreaPincode.label,
            pincodeId: pincodePerId,
            stateId: null,
            stateName: null,
            yearsAtCurrentAddress: 1,

            yearsInCurrentCity: 2,
          },
          emailAddress: data.permanentsAddressEmailAddress?.trim(),
          faxNumber: data.permanentsAddressFaxNumber,
          locality: data.permanentsAddressLocality,
          mobileNumbers: data.permanentsAddressMobileNumber?.trim().split(","),
          phoneNumbers: data.permanentsAddressphoneNumber?.trim().split(","),
          sameAsCurrentAddressFlag: !current,
        },
        currentAddressDTO: {
          address: {
            addressLine1: data.teamCurrentaddressLine1?.trim(),
            addressLine2: data.teamCurrentaddressLine2?.trim(),
            area: data.teamCurrentArea?.trim(),

            cityId: cityCurId,
            cityName: data.city_Cur,
            countryId: countryCurId,
            countryName: data.country_Cur?.trim(),
            landmark: data.teamCurrentLandmark,

            ownershipStatus: 2,
            pincode: data.teamCurrentAreaPincode.label,
            pincodeId: pincodeCurId,
            stateId: null,
            stateName: null,
            yearsAtCurrentAddress: data.teamCurrentTearsAtCurrentAdd,

            yearsInCurrentCity: data.teamCurrentYearInCity,
          },
          emailAddress: data.teamCurrentEmailAddress?.trim(),
          faxNumber: data.teamCurrentFaxNumber,
          locality: data.locality,
          mobileNumbers: data.teamCurrentMobileNumber?.trim().split(","),

          officeOwnership: {
            id: data.teamCurrentOwnership.value,
            name: data.teamCurrentOwnership.label,
          },
          phoneNumbers: data.teamCurrentphoneNumber?.trim().split(","),
        },
      };
    }

    if (saveAllIndication) {
      setHandleGetTeamAddress(values);
    } else {
      props
        .postData({ access_token, values, personId: props.personId })
        .then((res) => {
          if (res && res.status === 200) {
            setBtnDisable(false);
            message.success("Saved", 2);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            setBtnDisable(false);
            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    }
  }

  return (
    <div>
      <Form
        autoComplete="off"
        name="teamDetailsCurrentAddress"
        onFinish={submit}
        // initialValues={

        // }

        form={form}
      >
        <div className="inner-content">
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={6} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Current Address Details" />
                </div>
              </Col>
              <Col md={6} className="right-field-section">
                <Row>
                  <Col lg={12} xs={12} md={12} sm={12} className="">
                    <Col md={12} className="">
                      <FormItem
                        name="teamCurrentaddressLine1"
                        label="Address Line 1"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Address Line",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          maxLength={50}
                          type="text"
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} xs={12} md={12} sm={12}>
                    <Col md={12} className="team-mob-sec-1">
                      <FormItem
                        name="teamCurrentaddressLine2"
                        label="Address Line 2"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Address Line",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          maxLength={50}
                          type="text"
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={4} className="Nature-sec">
                      <FormItem
                        name="locality"
                        label="Locality"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Locality",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          maxLength={255}
                        />
                      </FormItem>
                    </Col>
                    <Col md={4} className="turnover">
                      <FormItem
                        name="teamCurrentLandmark"
                        label="Landmark"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Landmark",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          maxLength={50}
                        />
                      </FormItem>
                    </Col>
                    <Col md={4} className="turnover">
                      <FormItem
                        name="teamCurrentArea"
                        label="Area"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Firm Company Name",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          maxLength={255}
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={4} className="headoffic-sec mob-pincode-sec">
                      <FormItem
                        name="teamCurrentAreaPincode"
                        label="Pincode"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Pincode",
                          },
                        ]}
                      >
                        <AsyncSelect
                          cacheOptions
                          placeholder={"Type 3 digits"}
                          maxLength="7"
                          value={CurinputValue}
                          // getOptionLabel={(e) => e.label}
                          // getOptionValue={(e) => e.value}
                          loadOptions={loadPinCurcodes}
                          onInputChange={(e) => pincodeInputCurChange(e)}
                          onChange={pincodeDropCurChange}
                        />
                      </FormItem>
                    </Col>
                    <Col md={4} className="headoffic-sec-1">
                      <FormItem
                        name="city_Cur"
                        label="City"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter City",
                          },
                        ]}
                      >
                        <TextInput disabled={true} type="text" />
                      </FormItem>
                    </Col>
                    <Col md={4} className="headoffic-sec-1">
                      <FormItem
                        name="country_Cur"
                        label="Country"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Country",
                          },
                        ]}
                      >
                        <TextInput disabled={true} type="text" />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={4} className="headoffic-sec mob-sec-ow">
                      <FormItem
                        name="teamCurrentOwnership"
                        label="Ownership"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Ownership",
                          },
                        ]}
                      >
                        <UiDropDown data={ownStatusOptions1} />
                      </FormItem>
                    </Col>
                    <Col md={4} className="headoffic-sec mob-pincode-sec">
                      <FormItem
                        name="teamCurrentYearInCity"
                        label="Years in Current city"
                        colon={false}
                      >
                        <TextInput
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          type="text"
                          name="teamCurrentYearInCity"
                          validation={[
                            {
                              required: false,
                              message: "Years in Current city",
                            },

                            {
                              pattern: new RegExp("^[0-9]{0,3}$"),
                              message: "Enter value up to 999",
                            },
                          ]}
                        />
                      </FormItem>
                    </Col>
                    <Col md={4} className="headoffic-sec-1">
                      <FormItem
                        name="teamCurrentTearsAtCurrentAdd"
                        label="Years At Current Add"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "",
                          },
                          {
                            pattern: new RegExp("^[0-9]{0,3}$"),
                            message: "Enter value up to 999",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          type="text"
                          name="teamCurrentTearsAtCurrentAdd"
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={6} className="Mobile-sec team-mob-sec-2">
                      <FormItem
                        name="teamCurrentphoneNumber"
                        label="Phone Numbers (Comma Seperated)"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Firm Company Name",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          maxLength={255}
                        />
                      </FormItem>
                    </Col>
                    <Col md={7} className="Mobile-sec">
                      <FormItem
                        name="teamCurrentMobileNumber"
                        label="Mobile Numbers (Comma Seperated)"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Mobile Numbers",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          maxLength={255}
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={6} className="Mobile-sec fax-mob">
                      <FormItem
                        name="teamCurrentFaxNumber"
                        label="Fax Number"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Firm Company Name",
                          },
                        ]}
                      >
                        <TextInput
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          type="text"
                          maxLength={255}
                        />
                      </FormItem>
                    </Col>
                    <Col md={6} className="Mobile-sec">
                      <FormItem
                        name="teamCurrentEmailAddress"
                        label="Email Address"
                        colon={false}
                      >
                        <TextInput
                          maxLength={255}
                          type="email"
                          name="teamCurrentEmailAddress"
                          value={state.emailId}
                          validation={[
                            {
                              type: "email",
                              message: "Invalid Email!",
                            },
                            {
                              required: false,
                              message: "Email Required!",
                            },
                          ]}
                          onChange={onChangeTextHandler}
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }}>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={6} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Permanent Address Details" />
                </div>
              </Col>
              <Col md={6} className="right-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={12} className="checked-dark">
                      <FormItem
                        name="sPermanentsAddress"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Firm Company Name",
                          },
                        ]}
                      >
                        <Checkbox
                          checked={!current}
                          onClick={() => {
                            setCurrent(!current);
                          }}
                        >
                          Same as Current Address
                        </Checkbox>
                      </FormItem>
                    </Col>
                  </Col>
                </Row>

                {current && (
                  <>
                    <Row>
                      <Col lg={12} xs={12} md={12} sm={12} className="">
                        <Col md={12} className="">
                          <FormItem
                            name="PermanentsaddressLine1"
                            label="Address Line 1"
                            colon={false}
                            rules={[
                              {
                                required: true,
                                message: "Please Enter Address Line",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              maxLength={50}
                              type="text"
                            />
                          </FormItem>
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12} xs={12} md={12} sm={12}>
                        <Col md={12} className="team-mob-sec-1">
                          <FormItem
                            name="PermanentsaddressLine2"
                            label="Address Line 2"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Address Line",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              maxLength={50}
                              type="text"
                            />
                          </FormItem>
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="inner-field-right"
                      >
                        <Col md={4} className="Nature-sec">
                          <FormItem
                            name="permanentsAddressLocality"
                            label="Locality"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Locality",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              maxLength={255}
                            />
                          </FormItem>
                        </Col>
                        <Col md={4} className="turnover">
                          <FormItem
                            name="permanentsAddressLandmark"
                            label="Landmark"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Landmark",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              maxLength={50}
                            />
                          </FormItem>
                        </Col>
                        <Col md={4} className="turnover">
                          <FormItem
                            name="permanentsAddressArea"
                            label="Area"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Firm Company Name",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              maxLength={255}
                            />
                          </FormItem>
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="inner-field-right"
                      >
                        <Col md={4} className="headoffic-sec mob-pincode-sec">
                          <FormItem
                            name="permanentsAddressAreaPincode"
                            label="Pincode"
                            colon={false}
                            rules={[
                              {
                                required: true,
                                message: "Please Enter Pincode",
                              },
                            ]}
                          >
                            <AsyncSelect
                              cacheOptions
                              placeholder={"Type 3 digits"}
                              maxLength="7"
                              value={CurinputValue}
                              // getOptionLabel={(e) => e.label}
                              // getOptionValue={(e) => e.value}
                              loadOptions={loadPinPercodes}
                              onInputChange={(e) => pincodeInputPerChange(e)}
                              onChange={pincodeDropPerChange}
                            />
                          </FormItem>
                        </Col>
                        <Col md={4} className="headoffic-sec-1">
                          <FormItem
                            name="city_per"
                            label="city"
                            colon={false}
                            rules={[
                              {
                                required: true,
                                message: "Please Enter City",
                              },
                            ]}
                          >
                            <TextInput disabled={true} type="text" />
                          </FormItem>
                        </Col>
                        <Col md={4} className="headoffic-sec-1">
                          <FormItem
                            name="country_per"
                            label="country"
                            colon={false}
                            rules={[
                              {
                                required: true,
                                message: "Please Enter Country",
                              },
                            ]}
                          >
                            <TextInput disabled={true} type="text" />
                          </FormItem>
                        </Col>
                      </Col>
                    </Row>

                    <Row>
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="inner-field-right"
                      >
                        <Col md={6} className="Mobile-sec team-mob-sec-2">
                          <FormItem
                            name="permanentsAddressphoneNumber"
                            label="Phone Numbers (Comma Seperated)"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Phone Numbers",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              maxLength={255}
                            />
                          </FormItem>
                        </Col>
                        <Col md={7} className="Mobile-sec">
                          <FormItem
                            name="permanentsAddressMobileNumber"
                            label="Mobile Numbers (Comma Seperated)"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Mobile Numbers",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              maxLength={255}
                            />
                          </FormItem>
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="inner-field-right"
                      >
                        <Col md={6} className="Mobile-sec fax-mob">
                          <FormItem
                            name="permanentsAddressFaxNumber"
                            label="Fax Number"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Fax Number",
                              },
                            ]}
                          >
                            <TextInput
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                              }}
                              type="text"
                              maxLength={255}
                            />
                          </FormItem>
                        </Col>
                        <Col md={6} className="Mobile-sec">
                          <FormItem
                            name="permanentsAddressEmailAddress"
                            label="Email Address"
                            colon={false}
                            rules={[
                              {
                                required: false,
                                message: "Please Enter Email Address  ",
                              },
                            ]}
                          >
                            <TextInput
                              maxLength={255}
                              type="text"
                              name="permanentsAddressEmailAddress"
                              value={state.emailId}
                              onInput={(e) => {
                                if (e.target.value.trim() == "") {
                                  e.target.value = e.target.value.trim();
                                }

                                if (e.target.value.trim() !== "") {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              validation={[
                                {
                                  type: "email",
                                  message: "Invalid Email!",
                                },
                                {
                                  required: false,
                                  message: "Email Required!",
                                },
                              ]}
                              onChange={onChangeTextHandler}
                            />
                          </FormItem>
                        </Col>
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
            </Col>
          </Row>
          <div className="btnsection">
            <UiButton disabled={btnDisable} type="submit" title="Save" />
          </div>
          <hr></hr>
        </div>
      </Form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPermanent: (data) => dispatch(getPermanentAddressTeams(data)),

    getCurrent: (data) => dispatch(getCurrentAddressTeams(data)),

    // saveBranchLocationDetails: data => dispatch(saveBranchLocationDetails(data)),
    getPincodeList: (data) => dispatch(getPincodeOnSearch(data)),
    getBranchLocationByPincode: (data) =>
      dispatch(getBranchLocationByPincode(data)),
    getBranchLocationByArea: (data) => dispatch(getBranchLocationByArea(data)),
    getsvmdata: (data) => dispatch(getSVMListTeams(data)),
    postData: (data) => dispatch(postTeamDetails(data)),
    // getBranchLocationDetail: details => dispatch(getBranchLocationDetail(details))
  };
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    access_token: state.auth?.idToken,
    data: state.TeamDetails,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamDetailsCurrentAddress);
